import React from 'react';
import { Deck, Slayt, Metrik, MetrikSira, Tablo, Not, Dagilim, GrupSeridi, tl, sayi } from './EylulSlaytKit';

/**
 * KIXX Sports Club — Eylül 2026 medya planı. ÜÇ slayt, bütçe artırma talebi.
 *
 * 🔑 Bütçe müşteriden GELMEDİ, biz öneriyoruz: Ağustos gerçekleşen ₺59.219 → ₺150.000.
 *
 * Sayıların kaynağı:
 *  · Arama hacimleri  → Google Ads Keyword Planner, GenerateKeywordHistoricalMetrics,
 *    geo İstanbul (geoTargetConstants/21069), dil TR (1000), network GOOGLE_SEARCH.
 *    Çekim 31 Ağu 2026. ⚠️ Planner değerleri bucket'tır (…6.600, 8.100, 9.900…);
 *    bu yüzden pek çok kelimede Ağu→Eyl değişimi tam olarak +%22 çıkar — bu bir
 *    hata değil, iki komşu bucket arasındaki adımdır.
 *  · Marka verisi     → /api/group/hupalupa/monthly (canlı Meta + Google Ads),
 *    Kixx brandId d350d46e-fa7e-4aa0-98d6-317aca15c607.
 *  · Google kampanya kırılımı → fetch_google_ads_campaign_insights_live.py, müşteri 9593387784.
 *
 * ⚠️ Ağustos rakamları 31 Ağu 14:29 (TR) itibarıyladır; ayın son yarım günü eksik.
 */

const KW = '#8AFF00'; // KIXX yeşili

export default function KixxEylul2026() {
  return (
    <Deck
      marka="KIXX Sports Club"
      altBaslik="Metropol İstanbul AVM, Ataşehir · üyelik / lead · Meta + Google Search + YouTube + TikTok"
      logo="/kixx/img/kixx-logo-white.png"
      logoBg="bg-gray-900"
      butce={150000}
      oncekiButce={59219}
    >
      {/* ════════════ SLAYT 1 — TALEP ════════════ */}
      <Slayt
        no={1}
        etiket="Slayt 1 · Talep"
        accent="#0F766E"
        baslik="Eylül, spor salonu talebinin yılın ikinci zirvesi. Üst üste iki yıl aynı oran."
        spot="İstanbul'da KIXX'in gerçekten sattığı 12 hizmet sorgusunun toplam aylık arama hacmi, Ağustos'tan Eylül'e iki yıl üst üste yaklaşık beşte bir arttı. Bu bir tahmin değil, Google'ın kendi geçmiş verisi."
        dipnot="Kaynak: Google Ads Keyword Planner, geo İstanbul, dil Türkçe, yalnızca Google Arama (Arama Ortakları hariç). Sepet = spor salonu · spor salonu fiyatları · fitness salonu · ataşehir spor salonu · pilates · reformer pilates · personal trainer · spor salonu üyelik · yoga · spinning · kickbox · yakınımdaki spor salonu."
      >
        <MetrikSira kolon={4}>
          <Metrik etiket="Eylül 2025 · Ağustos'a göre" deger="+%19,9" alt="126.020 → 151.100 arama/ay" ton="iyi" />
          <Metrik etiket="Eylül 2024 · Ağustos'a göre" deger="+%18,1" alt="103.750 → 122.520 arama/ay" ton="iyi" />
          <Metrik etiket="Eylül'de açılan ek talep" deger="+25.080" alt="aylık ek arama (2025)" ton="iyi" />
          <Metrik etiket="2025'in en yüksek 3 ayı" deger="Oca · Eki · Eyl" alt="164.280 · 153.880 · 151.100" />
        </MetrikSira>

        <Tablo
          baslik="Kelime kelime — Ağustos → Eylül aylık arama hacmi (İstanbul)"
          basliklar={['Kelime', 'Ağu 2025', 'Eyl 2025', 'Değişim', 'Ağu 2024', 'Eyl 2024', 'Değişim']}
          saga={[1, 2, 3, 4, 5, 6]}
          satirlar={[
            ['spor salonu', '60.500', '74.000', { v: '+%22', ton: 'iyi', kalin: true }, '49.500', '60.500', { v: '+%22', ton: 'iyi' }],
            ['pilates', '33.100', '40.500', { v: '+%22', ton: 'iyi' }, '22.200', '27.100', { v: '+%22', ton: 'iyi' }],
            ['reformer pilates', '8.100', '9.900', { v: '+%22', ton: 'iyi' }, '8.100', '9.900', { v: '+%22', ton: 'iyi' }],
            ['yoga', '5.400', '6.600', { v: '+%22', ton: 'iyi' }, '6.600', '6.600', { v: '%0', ton: 'soluk' }],
            ['spinning', '4.400', '5.400', { v: '+%23', ton: 'iyi' }, '4.400', '5.400', { v: '+%23', ton: 'iyi' }],
            [{ v: 'ataşehir spor salonu', kalin: true }, '1.600', '1.900', { v: '+%19', ton: 'iyi', kalin: true }, '1.900', '2.400', { v: '+%26', ton: 'iyi' }],
            ['fitness salonu', '5.400', '5.400', { v: '%0', ton: 'soluk' }, '3.600', '3.600', { v: '%0', ton: 'soluk' }],
            ['yüzme havuzu', '9.900', '6.600', { v: '−%33', ton: 'kotu' }, '9.900', '6.600', { v: '−%33', ton: 'kotu' }],
          ]}
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
          <Not tip="iyi" baslik="Ataşehir özelinde talep daha da sert artıyor">
            KIXX'in bulunduğu ilçenin adını taşıyan <strong>"ataşehir spor salonu"</strong> sorgusu Eylül'de
            2024'te <strong>+%26</strong>, 2025'te <strong>+%19</strong> büyüdü. Bu, satın alma niyeti en yüksek
            ve rekabeti en pahalı sorgu: Google'ın verdiği sayfa üstü teklik aralığının üst ucu <strong>₺204,60</strong>.
            Eylül'de bu sorguda görünmemek, yılın en niyetli aramasını rakibe bırakmak demek.
          </Not>
          <Not tip="uyari" baslik="Karşı veri — havuz iletişimi Eylül'ün konusu değil">
            "yüzme havuzu" Eylül'de iki yıl da <strong>−%33</strong>. Havaların dönmesiyle havuz merakı düşüyor.
            Bu yüzden Eylül kreatifinde havuz ana mesaj olmamalı; öne çıkması gereken
            <strong> üyelik, pilates/reformer ve grup dersleri</strong>. Talep artışının tamamı bu üç başlıkta.
          </Not>
        </div>
      </Slayt>

      {/* ════════════ SLAYT 2 — KANIT ════════════ */}
      <Slayt
        no={2}
        etiket="Slayt 2 · Kanıt"
        accent="#B45309"
        baslik="Bütçe kısıldığında lead maliyeti değil, lead sayısı düştü."
        spot="Temmuz ve Ağustos aynı kurguyla, farklı bütçeyle çalıştı. Meta bütçesi %43 azaldı, lead %44 azaldı, lead başına maliyet %1,3 değişti. Yani bu hesapta lead sayısı doğrudan bütçenin fonksiyonu — verim tavanına çarpılmış değil."
        dipnot="Kaynak: canlı Meta Ads API (act_4522438977986893) ve Google Ads API (9593387784), /api/group/hupalupa/monthly. Ağustos rakamları 31 Ağustos 14:29 (TR) itibarıyladır; ayın son yarım günü bu tabloda yok."
      >
        <MetrikSira kolon={4}>
          <Metrik etiket="Temmuz · Meta lead maliyeti" deger="₺250,9" alt="₺71.002 → 283 lead" />
          <Metrik etiket="Ağustos · Meta lead maliyeti" deger="₺254,1" alt="₺40.398 → 159 lead" />
          <Metrik etiket="Birim maliyet değişimi" deger="+%1,3" alt="pratikte sabit" ton="iyi" />
          <Metrik etiket="Kaybedilen lead" deger="−124" alt="bütçe −%43 → lead −%44" ton="kotu" />
        </MetrikSira>

        <Tablo
          baslik="Kixx — son 6 ay, mecra bazında gerçekleşen"
          basliklar={['Ay', 'Meta', 'Google', 'Toplam', 'Lead', 'Meta lead maliyeti']}
          saga={[1, 2, 3, 4, 5]}
          satirlar={[
            ['Mart 2026', '₺63.267', { v: '—', ton: 'soluk' }, '₺63.267', '20', '₺3.163'],
            ['Nisan 2026', '₺56.446', { v: '—', ton: 'soluk' }, '₺56.446', '42', '₺1.344'],
            [{ v: 'Mayıs 2026', kalin: true }, { v: '₺134.397', kalin: true }, { v: '—', ton: 'soluk' }, { v: '₺134.397', kalin: true }, '54', '₺2.489'],
            ['Haziran 2026', '₺78.574', { v: '—', ton: 'soluk' }, '₺78.574', '44', '₺1.786'],
            [{ v: 'Temmuz 2026', kalin: true }, '₺71.002', { v: '—', ton: 'soluk' }, '₺71.002', { v: '283', ton: 'iyi', kalin: true }, { v: '₺251', ton: 'iyi', kalin: true }],
            [{ v: 'Ağustos 2026', kalin: true }, '₺40.398', '₺18.821', '₺59.219', { v: '159', ton: 'kotu', kalin: true }, { v: '₺254', kalin: true }],
          ]}
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
          <Not tip="iyi" baslik="₺150.000 yeni bir kapasite değil — hesap bunu zaten harcadı">
            Mayıs 2026'da bu hesapta tek başına Meta'ya <strong>₺134.397</strong> harcandı. Yani önerilen bütçe,
            hesabın daha önce çalıştırmadığı bir ölçek değil; sadece o ölçeğin <strong>doğru aya</strong> konması.
            Mayıs'ta lead maliyeti ₺2.489'du çünkü kurgu lead'e değil erişime çalışıyordu — Temmuz'da oturan
            3 hedef kitle + Lead kurgusu aynı parayı bugün <strong>on kat verimli</strong> harcıyor.
          </Not>
          <Not tip="riskli" baslik="Google Search Ağustos'ta ilk kez açıldı — ama ölçüm eksik">
            Haziran'dan beri planlanan Search kampanyası nihayet yayına girdi:
            <strong> Glowy_Search_KIXX_Generic</strong> ₺15.555 · 15.912 gösterim · 546 tık · CTR %3,43 · CPC ₺28,5.
            Trafik geldi, ancak hesapta yalnızca <strong>3 dönüşüm</strong> kayıtlı. 546 tıka 3 dönüşüm, kampanyanın
            değil <strong>dönüşüm kurulumunun</strong> sorunu gibi duruyor. Eylül bütçesi büyütülmeden önce
            kixx.com.tr üzerinde form/telefon dönüşümü tanımlanmalı — aksi halde Search'e giden para kör harcanır.
            YouTube ₺3.266'da kaldı (Ağustos planı ₺7.000 öngörmüştü), TikTok hiç açılmadı.
          </Not>
        </div>

        <Not tip="bilgi" baslik="Bir yıl önce bu markanın adı aranmıyordu">
          Google'da <strong>"kixx sports club"</strong> sorgusunun aylık hacmi Ağustos 2025'e kadar
          <strong> ölçüm eşiğinin altındaydı (0)</strong>. Eylül 2025'te ilk kez 40'a çıktı, bugün
          <strong> 880/ay</strong>. Marka talebi reklamla sıfırdan üretildi ve hâlâ büyüyor — Eylül,
          bu talebin kategori talebiyle aynı anda zirve yaptığı tek ay.
        </Not>
      </Slayt>

      {/* ════════════ SLAYT 3 — TALEP ════════════ */}
      <Slayt
        no={3}
        etiket="Slayt 3 · Talep"
        accent="#111827"
        baslik="Eylül 2026 için talebimiz: ₺150.000"
        spot="Ağustos'ta harcanan ₺59.219'un 2,5 katı. Gerekçesi tek cümlede: talep %20 artarken bütçeyi sabit tutmak, artan talebin payımıza düşen kısmını rakibe bırakmak demek — ve bu hesapta lead maliyeti sabit olduğu için ek bütçenin karşılığı doğrudan lead olarak geliyor."
        dipnot="Lead projeksiyonu Ağustos'un gerçekleşen ₺254,08 Meta lead maliyeti üzerine, Eylül'ün artan rekabeti için %10 birim maliyet payı eklenerek (₺279) hesaplandı. Google Search'ten gelecek lead projeksiyona DAHİL EDİLMEDİ — dönüşüm ölçümü kurulmadan sayı vermek doğru olmaz."
      >
        <MetrikSira kolon={4}>
          <Metrik etiket="Ağustos gerçekleşen" deger={tl(59219)} alt="Meta ₺40.398 + Google ₺18.821" />
          <Metrik etiket="Eylül talebi" deger={tl(150000)} alt="2,5× · +₺90.781" ton="iyi" />
          <Metrik etiket="Beklenen ölçülü lead" deger="320 – 355" alt="Ağustos: 159" ton="iyi" />
          <Metrik etiket="Hedef lead maliyeti" deger="₺254 – 279" alt="Ağustos seviyesi ± Eylül primi" />
        </MetrikSira>

        <div>
          <div className="text-[11px] font-semibold text-gray-700 mb-2.5">Mecra dağılımı</div>
          <Dagilim
            toplam={150000}
            kalemler={[
              { ad: 'Meta (Lead + Etkileşim)', tutar: 90000, renk: '#0F766E', not: '3 kitle · ana lead motoru' },
              { ad: 'Google Arama', tutar: 42000, renk: '#1D4ED8', not: 'jenerik + Ataşehir + marka' },
              { ad: 'YouTube', tutar: 12000, renk: '#B91C1C', not: 'kulüp tanıtımı, erişim' },
              { ad: 'TikTok', tutar: 6000, renk: '#111827', not: 'ilk açılış, test' },
            ]}
          />
        </div>

        <Tablo
          baslik="Ağustos gerçekleşen → Eylül plan"
          basliklar={['Mecra', 'Ağustos', 'Eylül planı', 'Değişim', 'Ne için']}
          saga={[1, 2, 3]}
          sarmala={[4]}
          satirlar={[
            ['Meta Ads', '₺40.398', { v: '₺90.000', kalin: true }, { v: '+%123', ton: 'iyi' }, 'Lead hacmi. Birim maliyeti kanıtlı tek kanal.'],
            ['Google Arama', '₺15.555', { v: '₺42.000', kalin: true }, { v: '+%170', ton: 'iyi' }, 'Eylül artışının yaşandığı yer talebin kendisi — arama.'],
            ['YouTube', '₺3.266', { v: '₺12.000', kalin: true }, { v: '+%267', ton: 'iyi' }, 'Ataşehir yakın çevre, kulüp tanıtım filmi.'],
            ['TikTok', { v: '₺0 — hiç açılmadı', ton: 'kotu' }, { v: '₺6.000', kalin: true }, { v: 'yeni', ton: 'iyi' }, 'Test. Çalışmazsa Ekim\'de kapatılır.'],
            [{ v: 'Toplam' }, '₺59.219', { v: '₺150.000' }, { v: '+%153', ton: 'iyi' }, ''],
          ]}
          vurguSonSatir
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
          <Not tip="riskli" baslik="Onaya bağlı tek şart">
            Google payı ₺42.000'e çıkıyor. Bu bütçenin serbest bırakılmasından <strong>önce</strong> kixx.com.tr'de
            form gönderimi ve telefon tıklaması dönüşüm olarak tanımlanmalı. Kurulum 5 Eylül'e yetişmezse
            Search ₺20.000'de tutulur, kalan ₺22.000 Meta'ya aktarılır — ay yine ₺150.000'le geçer,
            ama ölçülemeyen para harcanmaz.
          </Not>
          <Not tip="bilgi" baslik="Eylül biterken neye bakacağız">
            Tek başarı ölçütü <strong>ölçülü lead sayısı</strong>: hedef 320+. İkincil ölçüt lead maliyetinin
            ₺300'ün altında kalması. Eylül sonunda lead maliyeti ₺300'ü aşarsa Ekim bütçesi ₺150.000'de
            tutulmaz, ₺110.000'e çekilir. Ekim de talebin yüksek olduğu bir ay (153.880 arama), o yüzden
            karar Eylül verisiyle verilir, varsayımla değil.
          </Not>
        </div>

        <GrupSeridi vurgu="Kixx Sports Club" />
      </Slayt>
    </Deck>
  );
}
